import { Box, Typography } from '@locus-taxy/encore-mui';
import { useParams } from 'react-router-dom';

const capitalize = (s: string) => {
  if (typeof s !== 'string' || s.length === 0) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export default function CustomAppPage() {
  const params = useParams();
  // Get the first param value, regardless of its name (e.g., :appName)
  const pageName = Object.values(params)[0];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 3,
        textAlign: 'center',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h2">
        {capitalize(pageName || 'Application')}
      </Typography>
      <Typography variant="h6" color="text.secondary">
        This is a custom application page.
      </Typography>
      <Typography color="text.secondary" maxWidth={400}>
        The UI for this application is custom-built and lives outside of the
        standard grid view.
      </Typography>
    </Box>
  );
}
